export default {
  clusterId: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  paId: {
    value: null,
    options: [],
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/movimentacoes/clusters/link-form.js